import type { Clip } from "@/types/drama";

export default function ClipPreview({ clips }: { clips: Clip[] }) {
  if (clips.length === 0) return null;

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <h2 className="mb-4 flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
        <i className="ri-movie-line text-primary-500"></i>
        精彩片段回顾
      </h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {clips.map((clip) => (
          <div
            key={clip.title}
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-100"
          >
            <div className="relative h-40 w-full overflow-hidden bg-background-200">
              <img
                src={clip.image}
                alt={`${clip.title} 片段剧照`}
                title={`${clip.title} 精彩片段`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950/50 text-background-50">
                  <i className="ri-play-fill text-2xl"></i>
                </span>
              </span>
              <span className="absolute bottom-2 right-2 rounded bg-foreground-950/70 px-1.5 py-0.5 text-[10px] text-background-50">
                {clip.duration}
              </span>
            </div>
            <div className="p-3">
              <h3 className="text-sm font-medium text-foreground-900">{clip.title}</h3>
              <p className="mt-1 text-xs leading-relaxed text-foreground-600">{clip.desc}</p>
            </div>
          </div>
        ))}
      </div>
      <p className="mt-3 flex items-center gap-1 text-[11px] text-foreground-400">
        <i className="ri-information-line"></i>
        以上片段为图文演示内容，本站不提供在线视频播放功能。
      </p>
    </section>
  );
}